import styled from 'styled-components'
import { Card } from 'antd'

export const ContentCard = styled(Card)`
  box-shadow: rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px;
  cursor: pointer;
`
